import React from "react";
import { Home } from "lucide-react";

// Tela pública de pré-visualização de uma trilha (rota /familia/trilhas/<slug>).
// Não exige login: qualquer visitante (e o Google) pode ver título, descrição,
// duração e os títulos dos dias. O login só é pedido quando a pessoa toca em
// "Começar a trilha" (ver onStartDay, que reaproveita o openDay() existente e
// a mesma lógica de showProfilePrompt) — mesma lógica usada em EbookLanding.
export default function TrailLanding({
  trail,
  devotionals,
  onStartDay,
  onBack,
  renderBottomNav,
  isMobile,
  isTablet,
  isDesktop,
  styles
}) {
  const {
    containerStyle,
    fixedTopBarStyle,
    buttonReset,
    pageContentStyle,
    h1Style,
    overflowGuardStyle
  } = styles;

  if (!trail) return null;

  const accent = trail.color || "#E6B15A";
  const days = Array.isArray(devotionals) ? devotionals : [];
  const dayCount = days.length || trail.duration || 0;

  return (
    <div style={containerStyle}>
      <div style={{ ...fixedTopBarStyle, borderBottom: `2px solid ${accent}` }}>
        <button onClick={onBack} style={{ ...buttonReset, fontSize: 24, color: "#9CA3AF", marginRight: 20 }}>←</button>
        <span style={{ fontSize: 11, fontWeight: 700, color: "#FFFFFF", textTransform: "uppercase", letterSpacing: 1.5, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{trail.title}</span>
        <a href="/" aria-label="Voltar para o site institucional" title="Início do site" style={{ marginLeft: "auto", display: "inline-flex", alignItems: "center", justifyContent: "center", width: 34, height: 34, borderRadius: 999, color: "#9CA3AF", textDecoration: "none", flexShrink: 0 }}>
          <Home size={18} />
        </a>
      </div>

      <div style={pageContentStyle}>
        <article style={{ maxWidth: 720, width: "100%", boxSizing: "border-box", margin: "0 auto" }}>
          <div style={{ marginBottom: 28 }}>
            <p style={{ margin: "0 0 10px", fontSize: 11, letterSpacing: 2, color: accent, textTransform: "uppercase", fontWeight: 900 }}>Trilha devocional gratuita</p>
            <h1 style={{ ...h1Style, margin: 0, fontSize: isDesktop ? 42 : isTablet ? 34 : 27, lineHeight: 1.06, color: "#ffffff", fontWeight: 900 }}>{trail.title}</h1>
            <p style={{ margin: "10px 0 4px", fontSize: 15, lineHeight: 1.55, color: "#c7d1e4" }}>{trail.subtitle}</p>
            <p style={{ margin: "0 0 18px", fontSize: 12, color: "#7f8da3", fontWeight: 700 }}>{dayCount ? `${dayCount} dia${dayCount === 1 ? "" : "s"}` : ""}</p>
            <button
              onClick={onStartDay}
              style={{ ...buttonReset, minHeight: 48, padding: "0 22px", border: `1px solid ${accent}`, background: accent, color: "#111827", fontSize: 12, fontWeight: 950, textTransform: "uppercase", letterSpacing: 1 }}
            >
              Começar a trilha
            </button>
          </div>

          <section style={{ ...overflowGuardStyle, background: "linear-gradient(180deg, rgba(255,255,255,0.055), rgba(255,255,255,0.02))", border: "1px solid rgba(255,255,255,0.12)", borderTop: `4px solid ${accent}`, padding: isTablet ? 22 : 16, marginBottom: 20 }}>
            <p style={{ margin: "0 0 8px", fontSize: 11, letterSpacing: 2.2, color: "#8fa0bf", textTransform: "uppercase", fontWeight: 900 }}>Sobre esta trilha</p>
            <p style={{ margin: 0, fontSize: 14, lineHeight: 1.65, color: "#c7d1e4" }}>
              {trail.description || `${trail.title} é uma trilha devocional gratuita, disponível dentro do app Família Mosaico. Crie seu acesso para acompanhar os dias, salvar seu progresso e caminhar junto com outras pessoas.`}
            </p>
          </section>

          {days.length > 0 && (
            <section style={{ marginBottom: 24 }}>
              <p style={{ margin: "0 0 10px", fontSize: 11, letterSpacing: 2.2, color: "#8fa0bf", textTransform: "uppercase", fontWeight: 900 }}>Dias desta trilha</p>
              <ol style={{ margin: 0, padding: 0, listStyle: "none", display: "grid", gap: 8 }}>
                {days.map((devotional) => (
                  <li key={devotional.day} style={{ padding: "12px 14px", background: "rgba(255,255,255,0.045)", border: "1px solid rgba(255,255,255,0.1)", color: "#e5eaf3", fontSize: 13, fontWeight: 700, display: "flex", gap: 10, alignItems: "center" }}>
                    <span style={{ color: accent, fontWeight: 950 }}>{String(devotional.day).padStart(2, "0")}</span>
                    {devotional.title}
                  </li>
                ))}
              </ol>
            </section>
          )}

          <section style={{ textAlign: "center", padding: isTablet ? "28px 24px" : "22px 16px", background: "#111827", border: `1px solid ${accent}` }}>
            <p style={{ margin: "0 0 14px", fontSize: 14, lineHeight: 1.6, color: "#aeb9ca" }}>
              A trilha completa fica dentro do app, com seu progresso salvo depois de um cadastro rápido e gratuito.
            </p>
            <button
              onClick={onStartDay}
              style={{ ...buttonReset, minHeight: 48, padding: "0 22px", border: `1px solid ${accent}`, background: accent, color: "#111827", fontSize: 12, fontWeight: 950, textTransform: "uppercase", letterSpacing: 1 }}
            >
              Começar a trilha
            </button>
          </section>
        </article>
      </div>
      {renderBottomNav && renderBottomNav()}
    </div>
  );
}
